<template>
	<div class="repair">
		<div class="container">
			<div class="repair-content">
				
				<div class="content-one">
					<span>公司名称:</span>
					<input type="text" v-model="companyName" placeholder="请输入公司名称"/>
				</div>
				<div class="content-one">
					<span>项目名称:</span>
					<input type="text" v-model="projectName"  placeholder="请输入项目名称"/>
				</div>
				<div class="content-one">
					<span>项目地址:</span>
					<input type="text" v-model="projectdata"  placeholder="请输入项目地址"/>
				</div>
				<div class="content-one">
					<span>产品名称:</span>
					<input type="text" v-model="productName"  placeholder="请输入产品名称"/>
				</div>
				<div class="content-one">
					<span>产品型号:</span>
					<input type="text" v-model="producttype" placeholder="请输入产品型号"/>
				</div>
				<div class="content-one">
					<span><i>*</i>故障描述:</span>
					<input type="text" v-model="Speaking" class="speaking"  placeholder="请输入留言内容"/>
					<span class="hint">{{write}}</span>
				</div>
				<div class="content-one">
					<span>姓名:</span>
					<input type="text" v-model="Name"  placeholder="请输入姓名"/>
				</div>
				
				<div class="content-one">
					<span>地址:</span>
					<input type="text" v-model="data"  placeholder="请输入地址"/>
				</div>
				
				<div class="content-one">
					<span>手机:</span>
					<input type="text" v-model="phone"  placeholder="请输入手机"/>
				</div>
				
				<div class="content-one">
					<span><i>*</i>验证码:</span>
					<input type="text" class="code" v-model="Code"  placeholder="请输入验证码"/>
					<span class="hint">{{code}}</span>
				</div>
						
						
				<div class="content-one">
					<p @click="Submit()">提交</p>
				</div>	

			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		conponents:{},
		data(){
			return{
				msg:'repair',
				companyName:'',
				Speaking:'',
				Code:'',
				write:'',
				code:'',
				projectName:'',
				Name:'',
				data:'',
				phone:'',
				producttype:'',
				productName:'',
				projectdata:'',
				
				
			}
		},
		methods:{
			Submit(){
				if(this.Code==''|| this.Speaking==''){
					this.write ='描述故障不能为空';
					this.code ='验证码不能为空';
					$('.speaking').css('border','1px solid red');
					$('.code').css('border','1px solid red');
				}
			}
		},
		created(){
			
		}
	}
	
</script>

<style lang="less" scoped="scoped">
.repair{
	margin-top: 50px;
	margin-bottom: 50px;
	.repair-content{
			width: 100%;
			/*height: 600px;*/
			border:1px solid #eee;
			.content-one{
				margin: auto 200px;
				margin-top: 10px;
				span{
					font-size: 18px;
					margin-right: 20px;
					width: 100px;
					text-align: right;
					display: inline-block;
					i{
						color: red;
						padding-right: 10px;
					}
				}
				
				input{
					width: 400px;
					height: 35px;
					border: 1px solid #999;
					color: #ccc;
					font-size: 15px;
					padding-left: 20px;
				}
				.speaking{
					height: 230px;
					width: 640px;
					border:1px solid #ccc;
					display: inline-block;
				}
				.code{
					width: 200px;
				}
				.hint{
					font-size: 14px;
					display: inline-block;
					width: 300px;
					color: red;
					text-align: left;
				}
				p{
					width: 120px;
					height: 40px;
					background: #146BFF;
					color: #FFFFFF;
					font-size: 18px;
					text-align: center;
					line-height: 40px;
					border-radius: 5px;
					margin-top: 30px;
					margin-left: 120px;
					margin-bottom: 50px;
					cursor: pointer;
				}
			}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ServiceCenter/Scom/Repair.vue